import styled from "styled-components";

export const LoginFormWrapper = styled.form`
  display: flex;
  flex-direction: column;
  gap: 20px;
  width: 250px;
`;